import axiosClient from 'src/utils/axios-client';
import { AxiosResponse } from 'axios';
import { throttle } from '../config';
import type { ServicePriceMasterView, ServicePrice, ServicePriceQuery } from '../interfaces/masters/Price/price';
import { PaginationAndFilter } from '../interfaces/common/pagination';
import { wait } from '../utils/wait';

class ServicePriceApi {
  // calls POST api to add or update service price in the database
  async addServicePrice(price: ServicePrice):
  Promise<{ responseData: any, statusCode: number }> {
    if (throttle) {
      await wait(throttle);
    }

    try {
      const res = await axiosClient.post('master/price/service/', price).then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  // calls get API for fetching service Details in Add Service Price Page
  async getAllServicePrices(queryParams: ServicePriceQuery):
  Promise<{ responseData: ServicePriceMasterView[] | any, statusCode: number }> {
    if (throttle) {
      await wait(throttle);
    }

    try {
      const res = await axiosClient.get('master/price/service/all', { params: queryParams })
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  // calls get API for fetching service Details in View or edit Screen of Service Price
  async getServicePriceDetail(queryParams: ServicePriceQuery):
  Promise<{ responseData: ServicePriceMasterView[] | any, statusCode: number }> {
    if (throttle) {
      await wait(throttle);
    }

    try {
      const res = await axiosClient.get('master/price/service/details', { params: queryParams })
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async getServicePriceFilterData():
  Promise<AxiosResponse> {
    if (throttle) {
      await wait(throttle);
    }
    const response = await axiosClient.get('master/price/service/filters/data');
    return response;
  }

  async getServicesPriceByPaginationAndFilters(options: PaginationAndFilter):
  Promise<{ responseData: any, statusCode: number }> {
    if (throttle) {
      await wait(throttle);
    }
    try {
      const res = await axiosClient.post('master/price/service/getByPaginationAndFilter', options).then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }
}

export const servicePriceApi = new ServicePriceApi();
